import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { useModal } from 'hooks/modal/useModal';
import { FilterDashboardJuridiction } from 'hooks/search/useSearchJuridictionQuery';

import Filter from '../Filter/Filter';
import ModalCreate from '../Modals/ModalCreate';

import './DashboardHeader.less';

interface DashboardHeaderProps {
  totalCount: number;
  setFilter: (value: Partial<FilterDashboardJuridiction>) => void;
  filter: Partial<FilterDashboardJuridiction>;
  refreshDashboard: () => void;
}

export function DashboardHeader({
  totalCount,
  filter,
  setFilter,
  refreshDashboard,
}: DashboardHeaderProps): React.ReactElement {
  const modalCreation = useModal();

  const countString = `${totalCount} juridiction${
    totalCount > 1 ? 's' : ''
  } trouvée${totalCount > 1 ? 's' : ''}`;

  return (
    <div>
      <div className="dashboard-header-fields header-referentiels">
        <Filter filter={filter} setFilter={setFilter} />
        <AntdButton
          icon={<PlusOutlined />}
          type={'primary'}
          shape={'round'}
          onClick={modalCreation.open}
        >
          Créer une Juridiction
        </AntdButton>
        <ModalCreate
          visible={modalCreation.visible}
          close={modalCreation.close}
          refreshDashboard={refreshDashboard}
        />
      </div>
      <p>{countString}</p>
    </div>
  );
}

export default DashboardHeader;
